<template>
  <div class="wf-current-refinements">
    <div class="wf-current-refinements-title mb-1 text-uppercase filter-counter"  v-if="Object.keys(selectedFilters).length || inStock">
      {{ totalCount }} {{ $resourceString["product.search.filters.results.for"] }}
      <button class="clear-filters-btn text-uppercase text-decoration-none ml-3 pl-2" @click="clearAllFilters">{{$resourceString['inspiration.images.filters.clear.all']}}</button>
    </div>
    <div class="wf-current-refinements-group" v-for="[k, filterOptions] in Object.entries(selectedFilters)" :key="k">
      <template v-for="option in filterOptions">
        <a v-if="!isSingleCharOrNum(option) && !isUniqueProductId(option)" :key="option"
          class="btn font-size-12 mx-1 my-1 btn-light p-1">
          <span class="mr-3">
            {{ option == '1' ? $resourceString[`product.search.filters.current.${k.toLowerCase()}`] : option }}
          </span>
          <span class="png-icon png-icon-icons-glyph--k-close" @click="deselectFilter({ filterName: k, option })" />
        </a>
      </template>
    </div>
    <div class="wf-current-refinements-group" v-if="!!inStock" :key="inStock">
      <a class="btn font-size-12 mx-1 my-1 btn-light p-1">
        <span class="mr-3"> {{ $resourceString["product.search.filters.results.show.in.stock"] }}</span>
        <span class="png-icon png-icon-icons-glyph--k-close" @click="setInStock(null)" />
      </a>
    </div>
    <div class="wf-current-refinements-group" v-if="!!filterByFaceWeight" :key="filterByFaceWeight">
      <a class="btn font-size-12 mx-1 my-1 btn-light p-1">
        <span class="mr-3"> {{ $resourceString['product.Search.Filters.label.FilterFace'] }} </span>
        <span class="png-icon png-icon-icons-glyph--k-close" @click="setFilterByFaceWeight(false)" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      deselectFilter: "filters/deselectFilter",
      setInStock: "filters/setInStock",
      setFilterByFaceWeight: "filters/setFilterByFaceWeight",
    }),
    //Ensure URL params associated with back to search do not populate in current filters
    //Page param
    isSingleCharOrNum(option) {
      return option.toString().length <= 2 && /^[1-9][0-9]?$/.test(option.toString());
    },
    //ProductId param
    isUniqueProductId(option) {
      return /^[0-9]+-/.test(option.toString())
    },

    clearAllFilters(){
      this.$emit('clearAllFilters')
    }
  },
  computed: {
    ...mapGetters({
      selectedFilters: "filters/selectedFilters",
      inStock: "filters/inStock",
      filterByFaceWeight: "filters/filterByFaceWeight",
      totalCount: "productDisplay/totalCount",
    }),
  },
};
</script>
